import {NICEAgent} from './NICE_Agent.model';

export class NICEAgentState{
    public agentId: number;
    public agentStateId: number;
    public agentStateName: string;
    public businessUnitId: number;
    public contactId: number;
    public isActive: boolean;
    public isACW: boolean;
    public isOutbound: boolean;
    public firstName: string;
    public fromAddress: string;
    public lastName: string;
    public lastPollTime: string;
    public lastUpdateTime: string;
    public mediaName: string;
    public mediaType: number;
    public openContacts: number;
    public outStateDescription: string;
    public outStateCode: number;
    public skillId: number;
    public skillName: string;
    public startDate: string;
    public stationId: number;
    public stationPhoneNumber: string;
    public teamId: number;
    public teamName: string;
    public teamIsActive: boolean;
    public toAddress: string;
    public userName: string;
    public name: string;
    public sipUser: string;
    public isActiveAAC = false;
    constructor(data?: any) {
        if (data) {
            if (data instanceof NICEAgent) {
                this.agentId = data.agentId;
                this.agentStateId = -1;
                this.agentStateName = 'InActive';
                this.isActive = false;
                this.isACW = false;
                this.isOutbound = false;
                this.firstName = data.firstName;
                this.lastName = data.lastName;
                this.outStateDescription = '';
                this.outStateCode = -1;
                this.teamId = data.teamId;
                this.teamName = data.teamName;
                this.userName = data.userName == null? '' :data.userName;
                this.startDate = '';
                this.name = this.firstName + ' ' + this.lastName;

            }
            else
            {
                this.agentId = parseInt(data.agentId);
                this.agentStateId = parseInt(data.agentStateId);
                this.agentStateName = data.agentStateName;
                this.businessUnitId = parseInt(data.businessUnitId);
                this.contactId = parseInt(data.contactId);
                this.isActive = data.isActive === 'True';
                this.isACW = data.isACW  === 'True';
                this.isOutbound = data.isOutbound === 'True';
                this.firstName = data.firstName;
                this.fromAddress = data.fromAddress;
                this.lastName = data.lastName;
                this.lastPollTime = data.lastPollTime;
                this.lastUpdateTime = data.lastUpdateTime;
                this.mediaName = data.mediaName;
                this.mediaType = parseInt(data.mediaType);
                this.openContacts = parseInt(data.openContacts);
                this.outStateDescription = data.outStateDescription;
                this.outStateCode = parseInt(data.outStateId);
                this.skillId = parseInt(data.skillId);
                this.skillName = data.skillName;
                this.startDate = data.startDate;
                this.stationId = parseInt(data.stationId);
                this.stationPhoneNumber = data.stationPhoneNumber;
                this.teamId = parseInt(data.teamId);
                this.teamName = data.teamName;
                this.teamIsActive = data.teamIsActive ==='True';
                this.toAddress = data.toAddress;
                this.userName = data.userName;
                this.sipUser = data.sipUser;
                this.name = this.firstName + ' ' + this.lastName;

            }
        }
        else {
            this.agentId = 0;
            this.agentStateId = 0;
            this.agentStateName = '';
            this.businessUnitId = 0;
            this.contactId = null;
            this.isActive = false;
            this.isACW = false;
            this.isOutbound = false;
            this.firstName = '';
            this.fromAddress = '';
            this.lastName = '';
            this.lastPollTime = '';
            this.lastUpdateTime = '';
            this.mediaName = '';
            this.mediaType = 0;
            this.openContacts = 0;
            this.outStateDescription = '';
            this.outStateCode = 0;
            this.skillId = 0;
            this.skillName = '';
            this.startDate = '';
            this.stationId = 0;
            this.stationPhoneNumber = '';
            this.teamId = 0;
            this.teamName = '';
            this.toAddress = '';
            this.userName = '';
            this.name = this.firstName + ' ' + this.lastName;

        }
    }
}
